import { TowerControl } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { Radio } from "antd";
import { updateField } from "../../../../redux/slices/employee-slice";

const Eligibility = () => {
  const dispatch = useDispatch();
  const form = useSelector((state) => state.employeeForm);

  const handleChange = (name, e) => {
    dispatch(updateField({ name, value: e.target.value }));
  };

  return (
    <div className="flex items-start justify-between bg-white px-4">
      <div className="flex flex-col gap-3 mt-1">
        <TowerControl className="h-7 w-7 text-active-color stroke-1" />
        <h4 className="font-bold text-md">Eligibility</h4>
        <p className="text-gray-400 text-md -mt-2">
          Fill in the employee's eligibility details.
        </p>
      </div>
      <div className="bg-form-bg w-lg rounded-md px-4 flex flex-col gap-6 py-8 mt-5">
        <div className="flex flex-col gap-2">
          <h4 className="text-md font-normal">Medical Insurance</h4>
          <Radio.Group
            options={[
              { label: "Eligible", value: "eligible" },
              { label: "Not Eligible", value: "noteligible" },
            ]}
            onChange={(e) => handleChange("medical", e)}
            value={form.medical}
          />
        </div>
        <div className="flex flex-col gap-2">
          <h4 className="text-md ">Travel</h4>
          <Radio.Group
            options={[
              { label: "Eligible", value: "eligible" },
              { label: "Not Eligible", value: "noteligible" },
            ]}
            onChange={(e) => handleChange("travel", e)}
            value={form.travel}
          />
        </div>
        <div className="flex flex-col gap-2">
          <h4 className="text-md ">Bouns</h4>
          <Radio.Group
            options={[
              { label: "Eligible", value: "eligible" },
              { label: "Not Eligible", value: "noteligible" },
            ]}
            onChange={(e) => handleChange("bouns", e)}
            value={form.bouns}
          />
        </div>
      </div>
    </div>
  );
};

export default Eligibility;
